// extracted by mini-css-extract-plugin
module.exports = {"flexEndJustify":"SkeletonApplicationTableBody_flexEndJustify__2mX0d"};